'use client'

import { useEffect, useState, type ReactNode } from 'react'
import { whenThirdPartyAllowed } from '@/lib/defer-third-party'

/**
 * LCP/TBT için ağır client chunk’ları (GAM, WebPush/Firebase) etkileşim
 * veya load+fallback sonrasına erteler.
 */
export default function DeferredChrome({
  children,
  fallbackMs = 4_000,
}: {
  children: ReactNode
  fallbackMs?: number
}) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false
    let idleId: number | undefined
    let timer: number | undefined

    const arm = () => {
      void whenThirdPartyAllowed({ fallbackMs }).then(() => {
        if (!cancelled) setReady(true)
      })
    }

    if (typeof window.requestIdleCallback === 'function') {
      idleId = window.requestIdleCallback(arm, { timeout: fallbackMs + 1_500 })
    } else {
      timer = window.setTimeout(arm, Math.min(2_000, fallbackMs))
    }

    return () => {
      cancelled = true
      if (idleId !== undefined && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId)
      }
      if (timer !== undefined) window.clearTimeout(timer)
    }
  }, [fallbackMs])

  if (!ready) return null
  return <>{children}</>
}
